import clsx from 'clsx';
import React from 'react';
import { ColorMode } from '../../../core/interfaces/color-mode';
import { TABLE_TYPES_INFO_DATA } from '../constants/constants';
import { SchemaTableTypeData } from '../interfaces/interface';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { useActiveTheme } from '../../../theming/hooks/themeProvider';
import { HdButton, HdDocLink } from '../../../components';
import styles from './styles.module.scss';
import { TRACKER_TABLE_TYPE_SELECT_BUTTON_CLICK } from '../tracking/schemaBuilderTracking';

const dataIdGenerator = getDataIdGenerator('schema-builder');

export function FireboltTableTypeSelectionCardView({
  onTableTypeSelect
}: {
  onTableTypeSelect: (tableType: SchemaTableTypeData) => any
}) {
  const { eventTrack } = useAnalyticsTracker();

  const colorMode = useActiveTheme();

  return (
    <div className={clsx('row', styles.tableTypeContent)}>
      {TABLE_TYPES_INFO_DATA.map(tableTypeInfo => (
        <div className='col-xs-6'>
          <div className={clsx(styles.selectModeBox, 'select-mode-box p-3 focusable')}>
            <img
              alt={tableTypeInfo.description}
              className='mb-5 border-radius-md'
              src={
                colorMode === ColorMode.DARK
                  ? tableTypeInfo.imgDarkModeSrc
                  : tableTypeInfo.imgLightModeSrc
              }
            />
            <div className='no-item-box m-0 justify-between flex-1'>
              <div className='center-flex-col'>
                <strong className='mb-4'>{tableTypeInfo.title}</strong>

                <span className='no-item-box-desc mb-1'>
                  <div>{tableTypeInfo.description}</div>

                  <HdDocLink
                    section='firebolt_table_types'
                    docLink={tableTypeInfo.docLink}
                    dataId={dataIdGenerator('firebolt-table-types')}
                    className='mt-2'
                  />
                </span>
              </div>

              <HdButton
                className='mt-6 mb-2'
                dataId={dataIdGenerator(`select-table-type`)}
                onClick={() => {
                  eventTrack({
                    action: TRACKER_TABLE_TYPE_SELECT_BUTTON_CLICK,
                    properties: {
                      tableType: tableTypeInfo.tableType
                    }
                  });

                  onTableTypeSelect(tableTypeInfo);
                }}
              >
                Select
              </HdButton>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
